import React from 'react';
import usePayments from '../../../hooks/api/usePayments';
import { getIntl } from '../../../utils/intl';
import RegistrationCodePromptContents from './RegistrationCodePromptContents';
import ActiveRegistrationCodeAlert from './ActiveRegistrationCodeAlert';
import PromptButton from '../PromptButton';
import Stack from '../../v2BaseComponents/Stack';
import SkeletonLoadingContainer from '../../v2BaseComponents/SkeletonLoadingContainer';
import { Platform } from 'react-native';

const intl = getIntl('ButtonPromptRegistrationCodeConfiguration', {
    invitationOrCouponCodeButtonText: 'Invitation or Coupon Code?',
    invitationOrCouponCodeHeader: 'Invitation or Coupon Code',
});

export type ButtonPromptRegistrationCodeConfigurationOwnProps = {
    showMoreDetails?: boolean;
};

export type ButtonPromptRegistrationCodeConfigurationProps = ButtonPromptRegistrationCodeConfigurationOwnProps;

const ButtonPromptRegistrationCodeConfiguration: React.FC<ButtonPromptRegistrationCodeConfigurationProps> = ({
    showMoreDetails,
}) => {
    const isIOS = Platform.OS === 'ios';
    const { isLoadingRegistrationCodeStatus, myRegistrationCodeStatus } = usePayments({});

    const renderInCenteredContainer = (children: React.ReactNode) => (
        <Stack horizontal justify="center" fullWidth testID="registration-code-prompt-button-container">
            {children}
        </Stack>
    );

    const promptButton = (
        <PromptButton
            buttonProps={{
                title: intl('invitationOrCouponCodeButtonText'),
                variant: 'secondary',
                testID: 'registration-code-button',
                size: 'lg',
            }}
            renderPromptContents={(onClose) => <RegistrationCodePromptContents onClosePrompt={onClose} />}
            promptTitle="Invitation or Coupon Code"
        />
    );

    if (isLoadingRegistrationCodeStatus || !myRegistrationCodeStatus) {
        return isIOS
            ? null
            : renderInCenteredContainer(<SkeletonLoadingContainer isLoading>{promptButton}</SkeletonLoadingContainer>);
    } else if (myRegistrationCodeStatus.status.type === 'no-registration-code') {
        return isIOS ? null : renderInCenteredContainer(promptButton);
    } else {
        return (
            <ActiveRegistrationCodeAlert
                status={myRegistrationCodeStatus.status}
                disableRemoveCode={myRegistrationCodeStatus.status.forbidRemoval}
                showMoreDetails={showMoreDetails}
            />
        );
    }
};

export default React.memo(ButtonPromptRegistrationCodeConfiguration);
